import { HistorySettings } from 'app/modules/wallforming/components/menu-container/edit-menu/HistorySettings';
import { Redo } from 'app/modules/wallforming/components/menu-container/edit-menu/Redo';
import { RepeatHistory } from 'app/modules/wallforming/components/menu-container/edit-menu/RepeatHistory';
import { RepeatLast } from 'app/modules/wallforming/components/menu-container/edit-menu/RepeatLast';
import { Undo } from 'app/modules/wallforming/components/menu-container/edit-menu/Undo';
import { UndoHistory } from 'app/modules/wallforming/components/menu-container/edit-menu/UndoHistory';
import { Copy } from 'app/modules/wallforming/components/menu-container/object-menu/Copy';
import { Cut } from 'app/modules/wallforming/components/menu-container/object-menu/Cut';
import { Delete } from 'app/modules/wallforming/components/menu-container/object-menu/Delete';
import { DiscardSelection } from 'app/modules/wallforming/components/menu-container/object-menu/DiscardSelection';
import { EditGroup } from 'app/modules/wallforming/components/menu-container/object-menu/EditGroup';
import { Group } from 'app/modules/wallforming/components/menu-container/object-menu/Group';
import { Paste } from 'app/modules/wallforming/components/menu-container/object-menu/Paste';
import { Rotate } from 'app/modules/wallforming/components/menu-container/object-menu/Rotate';
import { SelectAll } from 'app/modules/wallforming/components/menu-container/object-menu/SelectAll';
import { Transform } from 'app/modules/wallforming/components/menu-container/object-menu/Transform';
import { Ungroup } from 'app/modules/wallforming/components/menu-container/object-menu/Ungroup';
import { AutosaveToggle } from 'app/modules/wallforming/components/menu-container/projects-menu/AutosaveToggle';
import { InputBindings } from 'app/modules/wallforming/components/menu-container/projects-menu/InputBindings';
import { LoadProject } from 'app/modules/wallforming/components/menu-container/projects-menu/LoadProject';
import { SaveProject } from 'app/modules/wallforming/components/menu-container/projects-menu/SaveProject';
import { SaveProjectAs } from 'app/modules/wallforming/components/menu-container/projects-menu/SaveProjectAs';
import { FocusBuilding } from 'app/modules/wallforming/components/menu-container/view-menu/FocusBuilding';
import { LockView } from 'app/modules/wallforming/components/menu-container/view-menu/LockView';

export const MenuActionItem = {
    Undo,
    Redo,
    UndoHistory,
    RepeatLast,
    RepeatHistory,
    HistorySettings,
    EditGroup,
    Group,
    Ungroup,
    Delete,
    SelectAll,
    Rotate,
    Transform,
    Cut,
    Copy,
    Paste,
    LockView,
    FocusBuilding,
    DiscardSelection,
    LoadProject,
    SaveProject,
    SaveProjectAs,
    AutosaveToggle,
    InputBindings
};
